import { render, staticRenderFns } from "./ModalInibirRestricoesCdaWa.vue?vue&type=template&id=7840c6ff&lang=pug"
import script from "./ModalInibirRestricoesCdaWa.vue?vue&type=script&lang=js"
export * from "./ModalInibirRestricoesCdaWa.vue?vue&type=script&lang=js"
import style0 from "./ModalInibirRestricoesCdaWa.vue?vue&type=style&index=0&id=7840c6ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports